import {
    Model
} from '@/lib/BaseModel';

var LayoutPreferencesSchema = {

    navBarSticky: {
        label: 'Navigation Bar: Make It Stay at Top of the Page',
        default: true,
        validation: {
            type: 'Boolean'
        }
    },
    showWelcomeBar: {
        label: 'Welcome Bar: Show It',
        default: true,
        validation: {
            type: 'Boolean'
        }
    },

}

var LayoutPreferences = Model.make('LayoutPreferences', LayoutPreferencesSchema);

export {
    LayoutPreferences
};